import React, { useState } from "react";
import { useMassArrivalContext } from "pages/mass-arrival/context/massArrivalContext"
import { MassArrivalCard } from "./Card";
import { ContainerCard, ContainerTable, ContainerWeek, TitleContainer, Wrapper } from "./styled";
import intl from "react-intl-universal";
import Loading from "components/center-loading";
import { MassArrivalResponseData, MassArrivalContextType, MassArrivalResponse } from "pages/mass-arrival/types";
import OrderDetailsModal from "../OrderDetailsModal/index.js";

interface MassArrivalTableProps {
  context: MassArrivalContextType;
}

interface MassArrivalTableState {
  selectedCard: MassArrivalResponseData | null;
  isModalOpen: boolean;
}

function MassArrivalTableWrapper() {
  const context = useMassArrivalContext();
  return <MassArrivalTable context={context} />;
}

const MassArrivalTable = (props: MassArrivalTableProps) => {
  const [selectedCard, setSelectedCard] = useState<MassArrivalResponseData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  
  const { massArrivals, isLoading } = props.context;

  const handleCardClick = (card: MassArrivalResponseData) => {
    if (card.ActualContainerQuantity > 0) {
      setSelectedCard(card);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  if (isLoading) {
    return <Loading
      isLoading
      fullHeightParent
    />
  }

  if (massArrivals == null || massArrivals?.length == 0) {
    return <div className='no-records-message'>{intl.get("supplierStock.message")}</div>
  }

  return (
    <Wrapper>
      <ContainerTable>
        {
          massArrivals.map((x: MassArrivalResponse) => (
            <ContainerWeek key={x.Week}>
              <TitleContainer>
                {intl.get('commons.week')} {x.Week}
              </TitleContainer>
              <ContainerCard>
                {x.Data?.map((cardData: MassArrivalResponseData) => (
                  <button 
                    key={`${cardData.CompanyCode}-${cardData.PortOfDischarge}`} 
                    onClick={() => handleCardClick(cardData)}
                    onKeyDown={(e) => {
                      if ((e.key === 'Enter' || e.key === ' ') && cardData.ActualContainerQuantity > 0) {
                        handleCardClick(cardData);
                      }
                    }}
                    style={{ 
                      cursor: cardData.ActualContainerQuantity > 0 ? 'pointer' : 'default',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      width: '100%',
                      textAlign: 'left',
                      pointerEvents: cardData.ActualContainerQuantity > 0 ? 'auto' : 'none'
                    }}
                    disabled={cardData.ActualContainerQuantity <= 0}
                    data-testid="mass-arrival-card"
                    data-clickable={cardData.ActualContainerQuantity > 0}
                    aria-label={`${intl.get('commons.view')} ${cardData.CompanyCode} ${cardData.PortOfDischarge}`}
                    aria-disabled={cardData.ActualContainerQuantity <= 0}
                  >
                    <MassArrivalCard {...cardData} />
                  </button>
                ))}
              </ContainerCard>
            </ContainerWeek>
          ))
        }
      </ContainerTable>

      {selectedCard && (
        <OrderDetailsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          orderDetails={selectedCard.OrderDetails}
        />
      )}
    </Wrapper>
  )
}

export { MassArrivalTableWrapper as MassArrivalTable }
